/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fields: NonNullable<unknown> }} Case_Create_Incomplete_SavedInputs */

const en_case_create_incomplete_saved = /** @type {(inputs: Case_Create_Incomplete_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Case saved. Creation is still incomplete: ${i?.fields}.`)
};

const pt_br2_case_create_incomplete_saved = /** @type {(inputs: Case_Create_Incomplete_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caso salvo. A criação ainda está incompleta: ${i?.fields}.`)
};

/**
* | output |
* | --- |
* | "Case saved. Creation is still incomplete: {fields}." |
*
* @param {Case_Create_Incomplete_SavedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_create_incomplete_saved = /** @type {((inputs: Case_Create_Incomplete_SavedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Create_Incomplete_SavedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_create_incomplete_saved(inputs)
	return pt_br2_case_create_incomplete_saved(inputs)
});